import { InputType } from 'src/app/common/components/reactive-form-builder/interfaces/input.interface';
import { Form, FormField, FormSection, FormType } from 'src/app/common/components/reactive-form-builder/interfaces/form.interface';
import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BaseForm } from 'src/app/view/base-form';
import { list } from 'src/app/common/classes/request-builder';
import { ActivatedRoute, Router } from '@angular/router';
import { DashboardService } from 'src/app/service/events/dashboard.service';
import { UsuariosApiService } from 'src/app/service/api/usuarios-api.service';
import paises from 'src/app/common/country';
import { StorageManager } from 'src/app/common/storage-manager.class';

import type { OnInit } from '@angular/core';
import { UserModel } from 'src/app/models/usuarios/user.model';
import type {
    ReactiveFormChangedField,
    ReactiveFormValue,
} from 'src/app/common/components/reactive-form-builder/interfaces/reactive-form-change.interface';

@Component({
    selector: 'app-usuarios-form',
    standalone: false,
    templateUrl: './usuarios-form.component.html',
    styleUrls: ['./usuarios-form.component.scss']
})
export class UsuariosFormComponent extends BaseForm<UserModel> implements OnInit {


    public appName = environment.appName;
    public applicationType = environment.features.applicationType;
    public clienteName: string = environment.features.clienteName;
    public showPerfilUnidades = environment.features.showPerfilUnidades;
    public lista_paises = list<string>([ '...', null ] ); 

    public override model: UserModel = {id: '', nombre: '', password: '', apellidos: '', rol: '', username: ''};
    public reactiveForm!: { formType: FormType; model: Partial<UserModel>; formFields: Form<UserModel> };
    public nifErrors = '';
    public passErrors = '';
    public showPassErrors = false;
    public isShowingPassword = false;

    public canRegister = environment.features.canRegister;


    public userRoles = list(
        ['Usuario normal', 'user'],
        ['Administrador', 'admin']
    );

    public userRolesDQAgro = list(
        ['Usuario normal', 'user'],
        ['Trabajador DQAgro', 'admin']
    );

    public userRolesCropGest = list(
        ['...', null],
        [this.clienteName, 'comunero'],
        [this.appName === 'avafitogest' ? 'Técnico' : this.appName === 'benibal' ? 'Asesor' : 'Aplicador', 'usuario'],
    );

    public formFieldsDatosCuenta: FormField<any>[] = [
    {
        name: 'username',
        field: 'username',
        vinculatedFields: undefined,
        label: 'Nombre de Usuario',
        input: { type: InputType.TEXT, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 1
    },
    {
        name: 'password',
        field: 'password',
        vinculatedFields: undefined,
        label: 'Contraseña',
        input: { type: InputType.PASSWORD, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 2
    },
    {
        name: 'password_repeat',
        field: 'password_repeat',
        vinculatedFields: undefined,
        label: 'Repetir contraseña',
        input: { type: InputType.PASSWORD, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 3
    },
    {
        name: 'sin_contraseña',
        field: 'sin_contraseña',
        vinculatedFields: undefined,
        label: '',
        input: { type: InputType.ONLY_TEXT, isEditable: false, style: 'color: red' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 4
    },
    {
        name: 'tipo',
        field: 'tipo',
        vinculatedFields: undefined,
        label: 'Tipo',
        input: { type: InputType.DROPDOWN, isEditable: true, data: this.userRolesCropGest, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,        values: this.userRolesCropGest,

        order: 5
    },
];

    public formFieldsDatosPersonales: FormField<any>[] = [
    {
        name: 'nombre',
        field: 'nombre',
        vinculatedFields: undefined,
        label: 'Nombre',
        input: { type: InputType.TEXT, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 1
    },
    {
        name: 'apellidos',
        field: 'apellidos',
        vinculatedFields: undefined,
        label: 'Apellidos',
        input: { type: InputType.TEXT, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 2
    },
    {
        name: 'email',
        field: 'email',
        vinculatedFields: undefined,
        label: 'Email',
        input: { type: InputType.TEXT, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 3
    },
    {
        name: 'telefono',
        field: 'telefono',
        vinculatedFields: undefined,
        label: 'Teléfono',
        input: { type: InputType.TEXT_MASK, isEditable: true, textMaskConfiguration: { mask: '999-999-999' } },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 4
    },
    {
        name: 'nif',
        field: 'nif',
        vinculatedFields: undefined,
        label: 'NIF',
        input: { type: InputType.TEXT_MASK, isEditable: true, textMaskConfiguration: { mask: '99999999-a' } },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 5
    },
    {
        name: 'nif',
        field: 'nif',
        vinculatedFields: undefined,
        label: 'CIF',
        input: { type: InputType.TEXT_MASK, isEditable: true, textMaskConfiguration: { mask: 'a-99999999' } },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 6
    },
    {
        name: 'tipo_carnet',
        field: 'tipo_carnet',
        vinculatedFields: undefined,
        label: 'Tipo de carnet',
        input: { type: InputType.DROPDOWN, isEditable: true, data: list(['...', null], 'BÁSICO', 'CUALIFICADO', 'FUMIGADOR', 'PILOTO', 'ASESOR'), optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,        values: list(['...', null], 'BÁSICO', 'CUALIFICADO', 'FUMIGADOR', 'PILOTO', 'ASESOR'),

        order: 7
    },
    {
        name: 'fecha_caducidad',
        field: 'fecha_caducidad',
        vinculatedFields: undefined,
        label: 'Fecha de caducidad',
        input: { type: InputType.CALENDAR, isEditable: true, calendarConfiguration: { calendarView: 'date', calendarDateFormat: 'dd/mm/yy' } },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 8
    },
    {
        name: 'ropo',
        field: 'ropo',
        vinculatedFields: undefined,
        label: 'ROPO',
        input: { type: InputType.TEXT, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 9
    },
];

    public formFields: FormField<any>[] = [
    {
        name: 'nombre',
        field: 'nombre',
        vinculatedFields: undefined,
        label: 'Nombre',
        input: { type: InputType.TEXT, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 1
    },
    {
        name: 'apellidos',
        field: 'apellidos',
        vinculatedFields: undefined,
        label: 'Apellidos',
        input: { type: InputType.TEXT, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 2
    },
    {
        name: 'tipo_carnet',
        field: 'tipo_carnet',
        vinculatedFields: undefined,
        label: 'Tipo de carnet',
        input: { type: InputType.DROPDOWN, isEditable: true, data: list(['...', null], 'BÁSICO', 'CUALIFICADO', 'FUMIGADOR', 'PILOTO', 'ASESOR'), optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,        values: list(['...', null], 'BÁSICO', 'CUALIFICADO', 'FUMIGADOR', 'PILOTO', 'ASESOR'),

        order: 3
    },
    {
        name: 'fecha_caducidad',
        field: 'fecha_caducidad',
        vinculatedFields: undefined,
        label: 'Fecha de caducidad',
        input: { type: InputType.CALENDAR, isEditable: true, calendarConfiguration: { calendarView: 'date', calendarDateFormat: 'dd/mm/yy' } },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 4
    },
    {
        name: 'nif',
        field: 'nif',
        vinculatedFields: undefined,
        label: 'NIF',
        input: { type: InputType.TEXT, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 5
    },
    {
        name: 'ropo',
        field: 'ropo',
        vinculatedFields: undefined,
        label: 'ROPO',
        input: { type: InputType.TEXT, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 6
    },
    {
        name: 'imei',
        field: 'imei',
        vinculatedFields: undefined,
        label: 'IMEI',
        input: { type: InputType.TEXT, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(environment.appName === 'manezylozano') },
        required: false,
        visible: environment.appName === 'manezylozano',
        order: 7
    },
    {
        name: 'pais',
        field: 'pais',
        vinculatedFields: undefined,
        label: 'País',
        input: { type: InputType.DROPDOWN_SEARCH, isEditable: true, data: this.lista_paises, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(environment.appName === 'manezylozano') },
        required: false,
        visible: environment.appName === 'manezylozano',        values: this.lista_paises,

        order: 8
    },
];

    public formFields2: FormField<any>[] = [
    {
        name: 'uds_medida',
        field: 'uds_medida',
        vinculatedFields: undefined,
        label: 'Unidad de medida',
        input: { type: InputType.DROPDOWN, isEditable: true, data: list('Hectáreas', 'Hanegadas', 'Taullas'), optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(this.showPerfilUnidades) },
        required: false,
        visible: this.showPerfilUnidades,        values: list('Hectáreas', 'Hanegadas', 'Taullas'),

        order: 1
    },
    {
        name: 'ratio_ha',
        field: 'ratio_ha',
        vinculatedFields: undefined,
        label: 'Relación con una hectárea',
        input: { type: InputType.NUMERIC, isEditable: true, placeholder: '1 Hectárea = X unidades' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(this.showPerfilUnidades) },
        required: false,
        visible: this.showPerfilUnidades,
        order: 2
    },
    {
        name: 'tipo_mando',
        field: 'tipo_mando',
        vinculatedFields: undefined,
        label: 'Tipo de mando',
        input: { type: InputType.DROPDOWN, isEditable: true, data: list(['...', null], 'SISTRONIC', 'TRONIC', 'SISTROMATIC', 'OZONO'), optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(this.appName === 'manezylozano') },
        required: false,
        visible: this.appName === 'manezylozano',        values: list(['...', null], 'SISTRONIC', 'TRONIC', 'SISTROMATIC', 'OZONO'),

        order: 3
    },
];

    public loginFormFields: FormField<any>[] = [
    {
        name: 'email',
        field: 'email',
        vinculatedFields: undefined,
        label: 'Email',
        input: { type: InputType.TEXT, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 1
    },
    {
        name: 'password',
        field: 'password',
        vinculatedFields: undefined,
        label: 'Contraseña',
        input: { type: InputType.PASSWORD, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 2
    },
    {
        name: 'password_repeat',
        field: 'password_repeat',
        vinculatedFields: undefined,
        label: 'Repetir contraseña',
        input: { type: InputType.PASSWORD, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 3
    },
];

    public roleFormFields: FormField<any>[] = [
    {
        name: 'rol',
        field: 'rol',
        vinculatedFields: undefined,
        label: 'Rol del usuario',
        input: { type: InputType.DROPDOWN, isEditable: true, data: this.applicationType === 'cropgest' ? this.userRolesCropGest : this.userRoles, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,        values: this.applicationType === 'cropgest' ? this.userRolesCropGest : this.userRoles,

        order: 1
    },
];




    private createReactiveForm(): void {
        const formType = Number(this.getType()) as FormType;
        this.reactiveForm = {
            formType,
            model: this.model,
            formFields: {
                name: 'usuarios',
                header: this.getType() === FormType.EDITION ? this.headerTitleWhenEdit : this.headerTitleWhenNew,
                type: formType,
                sections: this.getReactiveSections(),
                table: null,
                uploadButton: { isEnabled: Boolean(false), label: '' },
                signed: Boolean(false),
            },
        };
    }

    private getReactiveSections(): FormSection<UserModel>[] {
        const accountMode = this.canRegister || this.applicationType === 'cropgest';

        return [
            { name: 'Datos de cuenta', fields: this.formFieldsDatosCuenta, width: 12, isVisible: accountMode, order: 1 },
            { name: 'Datos personales', fields: this.formFieldsDatosPersonales, width: 12, isVisible: accountMode, order: 2 },
            { name: 'Datos principales', fields: this.formFields, width: 12, isVisible: !accountMode, order: 3 },
            { name: 'Datos adicionales', fields: this.formFields2, width: 12, isVisible: !accountMode, order: 4 },
            { name: 'Acceso', fields: this.loginFormFields, width: 12, isVisible: !accountMode && this.applicationType !== 'cropgest', order: 5 },
            { name: 'Rol', fields: this.roleFormFields, width: 12, isVisible: !accountMode, order: 6 },
        ];
    }

    public reactiveFormChanges(
        formModel: ReactiveFormValue<UserModel>,
        lastChangedFieldName: ReactiveFormChangedField<UserModel>,
    ): void {
        this.model = { ...this.model, ...formModel } as UserModel;
        (this.formChanges as (tag?: string) => void).call(this, String(lastChangedFieldName ?? ''));
        if (this.reactiveForm) {
            this.reactiveForm.model = this.model;
        }
    }

    constructor(
        public override route: ActivatedRoute,
        public override dashboard: DashboardService,
        public usuariosApi: UsuariosApiService,
        public override router: Router
    ) {
        super(
            route,
            router,
            dashboard,
            usuariosApi.usuariosPUT,
            usuariosApi.usuariosPOST,
            'usuarios',
            'Actualizar Usuario',
            'Crear Usuario'
        );
    }

    async ngOnInit() {
        if (this.appName === 'manezylozano') {
            await this.fillCountry();
        }

        if (this.appName === 'dqvademecum' && this.roleFormFields[0]) {
            this.roleFormFields[0].input.data = this.userRolesDQAgro;
        }

        this.createReactiveForm();
        if (this.getType() === FormType.CREATION) {
            this.model.tipo = 'usuario';
            this.userRolesCropGest.selected = 'usuario';
        }
        this.softInit(this.getType());
    }


    public formChanges() {
    
    
    }

    public validateNif() {
        if (this.getType() === FormType.CREATION) {
            const nifSearch = ((this.model || {}).nif || '').toLowerCase();

            if ((nifSearch || '').length === 0) {
                return true;
            }

            const existeNif = false;
            /*existeNif = (this.usuarios.values || [])
            .filter(it => it && it.value)
            .map(it => it.value)
            .find((nif) => (nif.nif || '').toLowerCase() === nifSearch);*/

            if (existeNif) {
                this.nifErrors = 'El usuario ya existe';
            } else {
                this.nifErrors = '';
            }

            return !existeNif;
        }

        return true;
    }

    public validatePassword() {
        this.showPassErrors = false;
        this.passErrors = '';

        if (this.model.password && (this.model.password.trim().length > 0)) {
            if (!this.model.password_repeat) {
                this.passErrors += 'Por favor, repita la contraseña.\n';
                return false;
            }
            if (this.model.password !== this.model.password_repeat) {
                this.passErrors += 'Las contraseñas no coinciden.\n';
                return false;
            }
            return true;
        }
        return true;
    }

    public togglePassword() {
        if (this.getType() === FormType.CREATION) {
            return;
        }
        if (!this.model.password) {   
            this.usuariosApi.usuariosGET.toPromise({  id: this.model.id, p3: StorageManager.getUser().id} as never).then(result => {
                if (result) {
                    this.model.password_old = result[0]?.password === null ? 'Sin Contraseña' : result[0]?.password ?? '';
                }
                return;
            }
            ).catch (e => {
                console.log('catch en getPosition: ' + e);
            }
            );
        }
        this.isShowingPassword = !this.isShowingPassword;
    }


    /**
     * Rellenamos el listado de países.
     * @returns 
     */
    fillCountry() {
        return new Promise( (resolve)  => {
            for (let index = 0; index < paises.length; index++) {
                const pais = { label: paises[index]?.label, value: paises[index]?.value} ;

                this.lista_paises.filtered.push({
                    label: pais.label ?? '',
                    value: pais.value ?? null,
                });
                if ( (index + 1 ) >= paises.length  ) { 
                    resolve(true);
                }
            }
        });
    }

}